(() => {
    window.addEventListener('parcelsRendered', function (e) {
        document.querySelectorAll('#trackandtrace__contentcontainer *[data-toggle="tooltip"]').forEach((tip) => {
            BSN.Tooltip(tip)
        })
    })
}) ()
